import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ADVANCED_PRODUCTS;
import { CloudBackupAndRecoverySVG, CloudContainerEngineSVG, CloudSearchServiceSVG, DataLakeInsightSVG, DataWarehouseServiceSVG, DistributedCacheServiceForMemcachedSVG, DistributedCacheServiceForRedisSVG, DistributedMessageServiceForKafkaSVG, DistributedMessageServiceForRabbitMqSVG, DocumentDatabaseServiceSVG, ElasticCloudServerSVG, ElasticLoadBalanceSVG, MapReduceServiceSVG, ObjectStorageServiceSVG, PlaceholderSVG, RelationalDatabaseServiceSVG, ScalableFileServiceSVG, ServerlessFunctionSVG, SnatSVG } from '@sbercloud/uikit-product-icons';
import { PLATFORM } from '../../../constants';
import { ADVANCED_PRODUCT } from './constants';
import { CLOUD_BACKUP_FORM_CONFIG, CLOUD_CONTAINER_ENGINE_FORM_CONFIG, CLOUD_SERVER_FORM_CONFIG, DATA_AS_YOU_USE_FORM_CONFIG, DATA_LAKE_INSIGHT_FORM_CONFIG, DATA_WAREHOUSE_SERVICE_FORM_CONFIG, DCS_REDIS_FORM_CONFIG, DMS_KAFKA_FORM_CONFIG, DOCUMENT_DATABASE_FORM_CONFIG, DSC_MEMCACHED_FORM_CONFIG, DSC_RABBIT_MQ_FORM_CONFIG, ELASTIC_LOAD_BALANCE_FORM_CONFIG, ELASTIC_SEARCH_FORM_CONFIG, FUNCTION_GRAPH_FORM_CONFIG, MAP_REDUCE_FORM_CONFIG, MYSQL_DATA_BASE_FORM_CONFIG, NETWORK_FORM_CONFIG, OBJECT_STORAGE_FORM_CONFIG, POSTGRE_SQL_DATA_BASE_FORM_CONFIG, SCALABLE_FILE_FORM_CONFIG, SQL_DATA_BASE_FORM_CONFIG } from './product-config';
export var ADVANCED_PRODUCTS = (_ADVANCED_PRODUCTS = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ADVANCED_PRODUCTS, ADVANCED_PRODUCT.AdvancedMySqlDataBase, {
  id: ADVANCED_PRODUCT.AdvancedMySqlDataBase,
  platform: PLATFORM.Advanced,
  label: 'Advanced Relational Database service for MySQL',
  caption: 'Базы данных с поддержкой MySQL',
  icon: RelationalDatabaseServiceSVG,
  dataTestId: 'advancedMySqlDataBase',
  formConfig: MYSQL_DATA_BASE_FORM_CONFIG,
  enableChangeProductQuantity: true
}), ADVANCED_PRODUCT.AdvancedDcsMemcached, {
  id: ADVANCED_PRODUCT.AdvancedDcsMemcached,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedDcsMemcached,
  formConfig: DSC_MEMCACHED_FORM_CONFIG,
  label: 'Advanced Distributed Cache Service for Memcached',
  caption: 'Кеширование данных в памяти на базе Memcached',
  icon: DistributedCacheServiceForMemcachedSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedDmsRabbitMq, {
  id: ADVANCED_PRODUCT.AdvancedDmsRabbitMq,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedDmsRabbitMq,
  formConfig: DSC_RABBIT_MQ_FORM_CONFIG,
  label: 'Advanced Distributed Message Service for RabbitMQ',
  caption: 'Брокер сообщений на базе RabbitMQ',
  icon: DistributedMessageServiceForRabbitMqSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedDcsRedis, {
  id: ADVANCED_PRODUCT.AdvancedDcsRedis,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedDcsRedis,
  formConfig: DCS_REDIS_FORM_CONFIG,
  label: 'Advanced Distributed Cache Service for Redis',
  caption: 'Кеширование данных в памяти на базе Redis',
  icon: DistributedCacheServiceForRedisSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancesDmsKafka, {
  id: ADVANCED_PRODUCT.AdvancesDmsKafka,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancesDmsKafka,
  formConfig: DMS_KAFKA_FORM_CONFIG,
  label: 'Advanced Distributed Message Service for Kafka',
  caption: 'Брокер сообщений на базе Apache Kafka',
  icon: DistributedMessageServiceForKafkaSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedMapReduce, {
  id: ADVANCED_PRODUCT.AdvancedMapReduce,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedMapReduce,
  formConfig: MAP_REDUCE_FORM_CONFIG,
  label: 'Advanced MapReduce Service',
  caption: 'Хранение, обработка и анализ больших данных',
  icon: MapReduceServiceSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedDataLakeInsight, {
  id: ADVANCED_PRODUCT.AdvancedDataLakeInsight,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedDataLakeInsight,
  formConfig: DATA_LAKE_INSIGHT_FORM_CONFIG,
  label: 'Advanced Data Lake Insight',
  caption: 'Сервис для обработки и анализа больших данных',
  icon: DataLakeInsightSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedDataAsYouUse, {
  id: ADVANCED_PRODUCT.AdvancedDataAsYouUse,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedDataAsYouUse,
  formConfig: DATA_AS_YOU_USE_FORM_CONFIG,
  label: 'Advanced DataArts Studio',
  caption: 'Хранение, вычисление и анализ больших данных',
  icon: PlaceholderSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedServerlessFunctions, {
  id: ADVANCED_PRODUCT.AdvancedServerlessFunctions,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedServerlessFunctions,
  label: 'Advanced Function Graph',
  caption: 'Запуск кода в бессерверной среде (serverless)',
  formConfig: FUNCTION_GRAPH_FORM_CONFIG,
  icon: ServerlessFunctionSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedElasticLoadBalance, {
  id: ADVANCED_PRODUCT.AdvancedElasticLoadBalance,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedElasticLoadBalance,
  label: 'Advanced Elastic Load Balance',
  caption: 'Сервис для балансировки сетевого трафика',
  formConfig: ELASTIC_LOAD_BALANCE_FORM_CONFIG,
  icon: ElasticLoadBalanceSVG,
  enableChangeProductQuantity: false
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ADVANCED_PRODUCTS, ADVANCED_PRODUCT.AdvancedObjectStorage, {
  id: ADVANCED_PRODUCT.AdvancedObjectStorage,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedObjectStorage,
  label: 'Advanced Object Storage Service',
  caption: 'Объектное хранилище, полностью совместимое с S3',
  formConfig: OBJECT_STORAGE_FORM_CONFIG,
  icon: ObjectStorageServiceSVG,
  enableChangeProductQuantity: true
}), ADVANCED_PRODUCT.AdvancedElasticsearch, {
  id: ADVANCED_PRODUCT.AdvancedElasticsearch,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedElasticsearch,
  label: 'Advanced Cloud Search Service',
  caption: 'Распределенная поисковая система на базе Elasticsearch',
  formConfig: ELASTIC_SEARCH_FORM_CONFIG,
  icon: CloudSearchServiceSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedDataWarehouseService, {
  id: ADVANCED_PRODUCT.AdvancedDataWarehouseService,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedDataWarehouseService,
  label: 'Advanced Data Warehouse Service',
  caption: 'Надежное хранилище корпоративных данных',
  formConfig: DATA_WAREHOUSE_SERVICE_FORM_CONFIG,
  icon: DataWarehouseServiceSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedScalableFile, {
  id: ADVANCED_PRODUCT.AdvancedScalableFile,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedScalableFile,
  label: 'Advanced Scalable File Service Turbo',
  caption: 'Масштабируемая файловая система NFS',
  formConfig: SCALABLE_FILE_FORM_CONFIG,
  icon: ScalableFileServiceSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedCloudBackup, {
  id: ADVANCED_PRODUCT.AdvancedCloudBackup,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedCloudBackup,
  label: 'Advanced Cloud Backup and Recovery',
  caption: 'Резервное копирование облачных дисков и серверов',
  formConfig: CLOUD_BACKUP_FORM_CONFIG,
  icon: CloudBackupAndRecoverySVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedCloudContainerEngine, {
  id: ADVANCED_PRODUCT.AdvancedCloudContainerEngine,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedCloudContainerEngine,
  label: 'Advanced Cloud Container Engine',
  caption: 'Управляемые высокопроизводительные кластеры Kubernetes',
  formConfig: CLOUD_CONTAINER_ENGINE_FORM_CONFIG,
  icon: CloudContainerEngineSVG,
  enableChangeProductQuantity: true
}), ADVANCED_PRODUCT.AdvancedSqlDatabase, {
  id: ADVANCED_PRODUCT.AdvancedSqlDatabase,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedSqlDatabase,
  label: 'Advanced Relational Database service for SQL Server',
  caption: 'Базы данных с поддержкой SQL Server',
  formConfig: SQL_DATA_BASE_FORM_CONFIG,
  icon: RelationalDatabaseServiceSVG,
  enableChangeProductQuantity: true
}), ADVANCED_PRODUCT.AdvancedPostgreSqlDatabase, {
  id: ADVANCED_PRODUCT.AdvancedPostgreSqlDatabase,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedPostgreSqlDatabase,
  label: 'Advanced Relational Database Service for PostgreSQL',
  caption: 'Базы данных с поддержкой PostgreSQL',
  formConfig: POSTGRE_SQL_DATA_BASE_FORM_CONFIG,
  icon: RelationalDatabaseServiceSVG,
  enableChangeProductQuantity: true
}), ADVANCED_PRODUCT.AdvancedDocumentDatabase, {
  id: ADVANCED_PRODUCT.AdvancedDocumentDatabase,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedDocumentDatabase,
  label: 'Advanced Document Database Service with MongoDB',
  caption: 'Распределенная реляционная БД с поддержкой MySQL',
  formConfig: DOCUMENT_DATABASE_FORM_CONFIG,
  icon: DocumentDatabaseServiceSVG,
  enableChangeProductQuantity: false
}), ADVANCED_PRODUCT.AdvancedCloudServer, {
  id: ADVANCED_PRODUCT.AdvancedCloudServer,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedCloudServer,
  label: 'Advanced Elastic Cloud Server',
  caption: 'Виртуальные машины для любых сценариев использования',
  formConfig: CLOUD_SERVER_FORM_CONFIG,
  icon: ElasticCloudServerSVG,
  enableChangeProductQuantity: true
}), _defineProperty(_ADVANCED_PRODUCTS, ADVANCED_PRODUCT.AdvancedNetwork, {
  id: ADVANCED_PRODUCT.AdvancedNetwork,
  platform: PLATFORM.Advanced,
  dataTestId: ADVANCED_PRODUCT.AdvancedNetwork,
  label: 'Advanced NAT Gateway',
  caption: 'NAT-шлюз для облачных и локальных серверов',
  formConfig: NETWORK_FORM_CONFIG,
  icon: SnatSVG,
  enableChangeProductQuantity: true
}));